<div class="pagination">
    <button class="chevron" (click)="previousPage()" [disabled]="currentPage == 1 ? true : null">
        <i-feather name="chevron-left"></i-feather>
    </button>
    <p><strong>{{currentPage}}</strong> / {{totalPages}}</p>
    <button class="chevron" (click)="nextPage()" [attr.disabled]="currentPage == totalPages ? true : null">
        <i-feather name="chevron-right"></i-feather>
    </button>
</div>
